import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("price", "Price, low to high", { field: "price", order: "asc" }),
    createSortOption("-price", "Price, high to low", { field: "price", order: "desc" }),
    // createSortOption("newest", "Newest First", { field: "datePublished", order: "asc" }),
    // createSortOption("oldest", "Oldest First", { field: "datePublished", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    currency: "USD"
}

export const popularSearches = [
    { text: "Next Ex", url: "/collections/the-next-ex" },
    { text: "Next Morning", url: "/collections/next-morning-shirt" },
    { text: "Denim", url: "/collections/denim" },
    { text: "Sparkle", url: "/collections/sparkle" },
];

export const colorFacets = {
    "black": "#000",
    "blue": "#0055b3",
    "brown": "#7D3F0F",
    "green": "#0A5C36",
    "grey": "#AAA",
    "neutral": "#f5e3d6",
    "pink": "#FFE5EC",
    "violet": "#795695",
    "white": "#FFF",
    "yellow": "#F9C70C",
}

export const imageSwiperOptions = {
    cssMode: false,
    loop: false,
    pagination: false,
    resistanceRatio: 0,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        1: {
            slidesPerView: 1,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: false,
            },
        },
        990: {
            slidesPerView: 1,
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            scrollbar: false,
        },
    },
}